import { X, Play } from 'lucide-react';

const VIDEO_URL  = 'https://youtu.be/Ai0szL0TFYo?si=_R3EgPpi_0nlQTdX';
const THUMB_URL  = 'https://img.youtube.com/vi/Ai0szL0TFYo/hqdefault.jpg';

export default function AnnouncementBanner({ onDismiss }) {
  return (
    <>
      <style>{`
        @keyframes cst-banner-slide {
          from { transform: translateY(-100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        .cst-watch-btn:hover { filter: brightness(1.08); }
        .cst-dismiss-btn:hover { background: rgba(255,255,255,0.15) !important; }
        .cst-thumb-link:hover .cst-play-ring { transform: scale(1.12); }
        .cst-play-ring { transition: transform 0.18s; }
      `}</style>

      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1001,
        height: 72,
        background: '#0B1F3A',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '2px solid rgba(201,168,76,0.35)',
        boxShadow: '0 4px 24px rgba(0,0,0,0.28)',
        animation: 'cst-banner-slide 0.32s cubic-bezier(0.22,1,0.36,1)',
        overflow: 'hidden',
      }}>

        {/* Subtle gradient overlay for depth */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(90deg, #091725 0%, #0B1F3A 30%, #0B1F3A 70%, #091725 100%)',
          pointerEvents: 'none',
        }} />

        {/* Thumbnail */}
        <a
          href={VIDEO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="cst-thumb-link"
          style={{ display: 'block', height: '100%', width: 128, flexShrink: 0, position: 'relative', overflow: 'hidden', zIndex: 1 }}
        >
          <img
            src={THUMB_URL}
            alt="Watch video"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
          {/* Dark overlay + play button */}
          <div style={{
            position: 'absolute', inset: 0,
            background: 'rgba(0,0,0,0.32)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div className="cst-play-ring" style={{
              width: 34, height: 34, borderRadius: '50%',
              background: '#FF0000',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 2px 10px rgba(0,0,0,0.4)',
            }}>
              <Play size={14} fill="#fff" color="#fff" style={{ marginLeft: 2 }} />
            </div>
          </div>
        </a>

        {/* Divider */}
        <div style={{ width: 1, height: 40, background: 'rgba(255,255,255,0.1)', flexShrink: 0, zIndex: 1 }} />

        {/* Text */}
        <div style={{ flex: 1, padding: '0 20px', zIndex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
            <span style={{
              background: '#FF0000', color: '#fff',
              fontSize: 10, fontWeight: 800,
              padding: '2px 7px', borderRadius: 4,
              letterSpacing: '0.04em', flexShrink: 0,
              fontFamily: 'Urbanist, sans-serif',
            }}>
              YOUTUBE
            </span>
            <p style={{
              margin: 0, fontSize: 14, fontWeight: 700, color: '#fff',
              fontFamily: 'Urbanist, sans-serif',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>
              New video from CA School of Trucking is live
            </p>
          </div>
          <p style={{
            margin: 0, fontSize: 12, color: 'rgba(255,255,255,0.55)',
            fontFamily: 'Urbanist, sans-serif',
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
          }}>
            See what makes our CDL training program stand out — watch now
          </p>
        </div>

        {/* Watch Now CTA */}
        <a
          href={VIDEO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="cst-watch-btn"
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '9px 20px', marginRight: 44,
            borderRadius: 8, flexShrink: 0,
            background: 'linear-gradient(135deg, #C9A84C, #D4A843)',
            color: '#0B1F3A',
            fontWeight: 700, fontSize: 13,
            textDecoration: 'none',
            fontFamily: 'Urbanist, sans-serif',
            whiteSpace: 'nowrap',
            zIndex: 1,
            transition: 'filter 0.15s',
          }}
        >
          <Play size={12} fill="#0B1F3A" color="#0B1F3A" style={{ marginLeft: 1 }} />
          Watch Now
        </a>

        {/* Dismiss */}
        <button
          onClick={onDismiss}
          className="cst-dismiss-btn"
          aria-label="Dismiss"
          style={{
            position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,0.08)',
            border: '1px solid rgba(255,255,255,0.12)',
            width: 30, height: 30, borderRadius: 6,
            cursor: 'pointer', zIndex: 2,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'rgba(255,255,255,0.55)',
            transition: 'background 0.15s',
            padding: 0,
          }}
        >
          <X size={14} />
        </button>

      </div>
    </>
  );
}
